import React from 'react';
import {getIdentity} from '../utils/identity';

const useIdentity = (privateKey: string) => {
  const identity = React.useMemo(() => {
    if (privateKey) {
      return getIdentity(privateKey);
    }
    return undefined;
  }, [privateKey]);
  return identity;
};

export default useIdentity;
